import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';

const SearchableSelect = ({ label, options, value, onChange, onBlur, error, required, name }) => (
  <Autocomplete
    options={options}
    getOptionLabel={(option) => option.label || ''}
    value={options.find(opt => opt.label === value) || null}
    onChange={(event, newValue) => {
      // Call the onChange prop with a synthetic event that mimics a standard input change event
      onChange({
        target: {
          name,
          value: newValue ? newValue.label : '',
        },
      });
    }}
    onBlur={onBlur}
    renderInput={(params) => (
      <TextField
        {...params}
        label={label}
        error={error}
        required={required}
        variant="standard"
        size="small"
      />
    )}
    isOptionEqualToValue={(option, value) => option.label === value?.label}
  />
);

export default SearchableSelect;
